// Import toàn bộ Bootstrap (đã bao gồm Popper.js)
// import 'bootstrap';

// Hoặc nếu bạn muốn chỉ định rõ file bundle:
// import 'bootstrap/dist/js/bootstrap.bundle.js';

// Chỉ lấy Modal và Tab chẳng hạn
import { Tooltip, Tab, Modal } from 'bootstrap';
import './swiper-init.js';


// Đảm bảo jQuery sẵn sàng trước khi gọi các hàm của Bootstrap nếu cần
(function ($) {
  $(function () {
    // Ví dụ kích hoạt toàn bộ Tooltip
    $('[data-bs-toggle="tooltip"]').each(function () {
      new Tooltip(this);
    });
  });

  // Mobile Menu Toggle
  (function () {
    const overlay = document.getElementById('mobile-menu-overlay');
    const btnOpen = document.getElementById('btn-mobile-menu');
    const btnClose = document.getElementById('btn-mobile-menu-close');
    if (!overlay) return;

    function openMenu() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mobile-menu-open');
    }

    function closeMenu() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-menu-open');
    }

    if (btnOpen) btnOpen.addEventListener('click', openMenu);
    if (btnClose) btnClose.addEventListener('click', closeMenu);

    overlay.querySelectorAll('.mobile-nav-list a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        const parentLi = this.parentElement;
        if (parentLi && parentLi.classList.contains('menu-item-has-children')) {
          e.preventDefault();
          $(this).siblings('.sub-menu').slideToggle(300);
          parentLi.classList.toggle('is-active');
        } else {
          closeMenu();
        }
      });
    });
  })();
})(jQuery);
